var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"0px","margin-bottom":"0px"},style:({height:_vm.iframeHeight + 'px'})},[_c('iframe',{ref:"moduleFrame",staticStyle:{"width":"0","min-width":"100% !important","height":"100%"},attrs:{"src":_vm.iframeSRC,"allowfullscreen":"","scrolling":"yes","frameborder":"0","allowtransparency":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }